/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Musculation_HelpInputs */

const fr_admin_subscription_rights_musculation_help = /** @type {(inputs: Admin_Subscription_Rights_Musculation_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déduit du palier (Muscu ou Crossfit ALL-IN), non modifiable séparément.`)
};

/**

* @param {Admin_Subscription_Rights_Musculation_HelpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_musculation_help = /** @type {((inputs?: Admin_Subscription_Rights_Musculation_HelpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Musculation_HelpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_musculation_help(inputs)
});